export default __webpack_public_path__ + "static/media/Untitled-2.8e4005b7.png";